module.exports = __webpack_public_path__ + "static/media/ZCOC.63f2ae96.pdf";